import { render, staticRenderFns } from "./childs.vue?vue&type=template&id=62f71d74&"
import script from "./childs.vue?vue&type=script&lang=js&"
export * from "./childs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports